import { render } from "./BrochureCard.vue?vue&type=template&id=08b88588&scoped=true"
import script from "./BrochureCard.vue?vue&type=script&lang=js"
export * from "./BrochureCard.vue?vue&type=script&lang=js"

import "./BrochureCard.vue?vue&type=style&index=0&id=08b88588&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b88588"]])

export default __exports__